module.exports = __webpack_public_path__ + "static/media/web logos_UN_colour.16fa7646.jpg";